import { format, parseISO, isValid } from "date-fns";

function toDate(value?: string | number | Date | null): Date | null {
  if (value == null) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === "number") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const trimmed = String(value).trim();
  if (!trimmed) return null;
  const d = parseISO(trimmed);
  return isValid(d) ? d : null;
}

export function formatUsDate(value?: string | number | Date | null): string {
  const d = toDate(value);
  if (!d) return "-";
  return format(d, "MM-dd-yyyy");
}

export function formatUsDateTime(value?: string | number | Date | null): string {
  const d = toDate(value);
  if (!d) return "-";
  // UI standard: show dates as MM-dd-yyyy (no time) everywhere.
  return format(d, "MM-dd-yyyy");
}
